var _defs, _g, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 50,
    viewBox: "0 0 200 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "textGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7678ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FF9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iconGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7678ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FF9D"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,25 C8,13.95 16.95,5 28,5 L32,5 C43.05,5 52,13.95 52,25 C52,36.05 43.05,45 32,45 L28,45 C16.95,45 8,36.05 8,25 Z M18,25 C18,30.52 22.48,35 28,35 L32,35 C37.52,35 42,30.52 42,25 C42,19.48 37.52,15 32,15 L28,15 C22.48,15 18,19.48 18,25 Z",
    fill: "url(#iconGradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 2,
    fill: "#00FF9D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 15,
    r: 2,
    fill: "#00FF9D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 35,
    r: 2,
    fill: "#00FF9D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 35,
    r: 2,
    fill: "#00FF9D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 15,
    x2: 45,
    y2: 35,
    stroke: "#00FF9D",
    strokeWidth: 1,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 35,
    x2: 45,
    y2: 15,
    stroke: "#00FF9D",
    strokeWidth: 1,
    opacity: 0.7
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 33,
    fontFamily: "Arial, sans-serif",
    fontWeight: 700,
    fontSize: 24,
    fill: "url(#textGradient)"
  }, "DESOL AI")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 45,
    fontFamily: "Arial, sans-serif",
    fontSize: 9,
    fill: "#7678ED"
  }, "Decentralized Intelligence")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3c645dfc10c29853a3ff612041bee4b5.svg";
export { ForwardRef as ReactComponent };